import React from 'react';
import Services from '../../../components/divisions/divisionProductions/services/Services';
import DivisionLayout from '../../../layouts/DivisionLayout';

function ServicesProductions() {
  const links = {
    about: '/division/productions/about',
    services: '/division/productions/services',
    work: '/division/productions/work',
  };
  return (
    <DivisionLayout colorClass="bg-bayside-cyan" links={links} divisionName="productions">
      <Services />
    </DivisionLayout>
  );
}

export default ServicesProductions;
